<script>
import { Bar } from "vue-chartjs";
import "@/plugins/chart";

export default {
    name: "TeamLoadChart",
    extends: Bar,
    props: {
        labels: {
            type: Array,
            default: () => [],
        },
        rpe: {
            type: Array,
            default: () => [],
        },
        acwr: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        theme(vm = this) {
            return vm.$vuetify.theme.currentTheme
        },
        acwrPointColors(vm = this) {
            return vm.acwr.map(v => (v >= 0.8 && v <= 1.3) ? vm.theme.secondary : vm.theme.error)
        },
        hasAcwr(vm = this) {
            return vm.acwr.some(v => v > 0)
        },
        data(vm = this) {
            const datasets = [{
                type: 'bar',
                label: 'RPE',
                yAxisID: 'rpe',
                data: vm.rpe,
                backgroundColor: 'rgba(102,204,204,0.28)',
                hoverBackgroundColor: 'rgba(102,204,204,0.45)',
                categoryPercentage: 0.6,
                barPercentage: 0.85,
                order: 1,
            }]
            if (vm.hasAcwr) {
                datasets.unshift({
                    type: 'line',
                    label: 'ACWR',
                    yAxisID: 'acwr',
                    data: vm.acwr,
                    borderColor: vm.theme.secondary,
                    backgroundColor: 'transparent',
                    borderWidth: 2.5,
                    pointBackgroundColor: vm.acwrPointColors,
                    pointBorderColor: vm.acwrPointColors,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                    lineTension: 0.3,
                    fill: false,
                    order: 0,
                })
            }
            return { labels: vm.labels, datasets }
        },
        options(vm = this) {
            const theme = vm.theme
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        gridLines: { display: false },
                        ticks: { fontColor: theme.txtMuted, fontSize: 10 },
                    }],
                    yAxes: [
                        {
                            id: 'rpe',
                            position: 'left',
                            gridLines: { color: theme.outline, zeroLineColor: theme.outline, drawBorder: false },
                            ticks: { beginAtZero: true, max: 10, fontColor: theme.txtMuted, fontSize: 10, precision: 0 },
                        },
                        ...(vm.hasAcwr ? [{
                            id: 'acwr',
                            position: 'right',
                            gridLines: { display: false, drawBorder: false },
                            ticks: { beginAtZero: true, suggestedMax: 1.6, fontColor: theme.txtMuted, fontSize: 10 },
                        }] : []),
                    ],
                },
                legend: { display: false },
                tooltips: {
                    mode: "index",
                    intersect: false,
                    backgroundColor: theme.surface2,
                    titleFontColor: theme.txtPrimary,
                    bodyFontColor: theme.txtSecondary,
                    borderColor: theme.outline,
                    borderWidth: 1,
                    cornerRadius: 8,
                    xPadding: 10,
                    yPadding: 8,
                    titleFontFamily: '"Outfit", sans-serif',
                    bodyFontFamily: '"Outfit", sans-serif',
                    callbacks: {
                        label: function (tooltipItem, chartData) {
                            const ds = chartData.datasets[tooltipItem.datasetIndex] || {}
                            const value = Number(tooltipItem.value)
                            return `${ds.label || ''}: ${value.toFixed(2)}`
                        },
                    },
                },
            }
        },
    },
    mounted() {
        this.renderChart(this.data, this.options)
    },
    watch: {
        data() {
            this.renderChart(this.data, this.options)
        },
        options() {
            this.renderChart(this.data, this.options)
        },
    },
}
</script>
